import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function AgentDriftHero() {
  return <section className="relative w-full pt-32 pb-24 px-6 md:px-12 lg:px-24 overflow-hidden bg-white" data-id="element-74">
      {/* Background Image */}
      <div className="absolute top-0 right-0 pointer-events-none" style={{
      width: '100%',
      height: '800px'
    }} data-id="element-75">
        <img src="https://cdn.magicpatterns.com/uploads/kga88EcdPJUPTBaJUremGs/background_thought.png" alt="" className="absolute right-0 top-[12%] w-[100%] h-auto opacity-90" data-id="element-76" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-77">
        <div className="flex flex-col space-y-8" data-id="element-78">
          <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-200 bg-gray-50 mt-10 w-fit" data-id="element-79">
            <span className="text-xs font-medium text-gray-600 uppercase tracking-wider font-sans" data-id="element-80">
              AGENT GOVERNANCE
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold leading-[0.95] tracking-tight text-black max-w-5xl font-['Syne']" data-id="element-81">
            The Agent{' '}
            <span className="bg-blue-600 text-white px-3" data-id="element-82">Constitution</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl font-light" data-id="element-83">
            <strong className="text-black font-semibold" data-id="element-84">
              Agents don't break. They drift.
            </strong>{' '}
            Every reasoning step pulls them slightly further from your rules,
            your standards, your intent. Synthia provides the constitutional
            layer that keeps autonomous agents faithful to the institution they
            serve — continuously, not just at the prompt.
          </p>

          <div className="pt-4 flex flex-col gap-8" data-id="element-85">
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-black transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0066FF] w-fit" data-id="element-86">
              BOOK A DEMO
              <ArrowRight className="w-5 h-5" data-id="element-87" />
            </Link>

            <div className="flex flex-wrap gap-3 md:gap-4" data-id="element-88">
              <span className="text-xs font-bold text-[#0066FF] uppercase tracking-wider bg-blue-50 border border-blue-100 px-4 py-2 rounded-full font-sans" data-id="element-89">
                Constitutional authoring
              </span>
              <span className="text-xs font-bold text-orange-700 uppercase tracking-wider bg-orange-50 border border-orange-100 px-4 py-2 rounded-full font-sans" data-id="element-90">
                Real-time fidelity monitoring
              </span>
              <span className="text-xs font-bold text-teal-700 uppercase tracking-wider bg-teal-50 border border-teal-100 px-4 py-2 rounded-full font-sans" data-id="element-91">
                Autonomous drift correction
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}